export interface GlobalConfiguration {
  genericPool: string;

  genericTollfreePool: string;

  genericEmail: string;
}
